export const responsiveFlexDir: Array<any> = ['column', 'column', 'row'];
export const responsiveSpacing: Array<number> = [0, 0, 4];
export const phoneRegExp = /^(\+\d{1,2}\s)?\(?\d{3}\)?[\s.-]?\d{3}[\s.-]?\d{4}$/;
